/* This file was automatically generated by tools management permissions. It should not be changed manually. */
import {REG} from "lib/commons/registry";
import "lib/wsp/wsp_Perms";

const r = REG.reg;
r.newPerm("action.chain#manage.wsps", "admin.wsp", 0);
r.newPerm("action.pack#install.skinPack", "install.skinPack", 0);
r.newPerm("action.pack#install.wspPack", "install.wspPack", 0);
r.newPerm("action.wsp#read.props", "read.wsp", 0);
r.newPerm("action.wsp#reload", "reload.wsp", 0);
r.newPerm("action.wsp#removeCache", "remove.cache.wsp", 0);
r.newPerm("action.chain#create.wsp", "create.wsp", 0);
r.newPerm("action.drf#commit", "commit.drf", 0);
r.newPerm("action.drf#revert", "revert.drf", 0);
r.newPerm("action.drv#deleteOvr", "delete.drvOverride", 0);
r.newPerm("action.drv#markDone", "mark.drvOverrideDone", 0);
r.newPerm("action.item#import.resFile", "write.node.update", 4);
r.newPerm("action.src#copyTo", "write.node.copyTo", 128);
r.newPerm("action.src#importTo", "write.node.import", 128);
r.newPerm("action.src#moveTo", "write.node.moveTo", 128);
r.newPerm("action.space#set.perms", "admin.node.configRoles", 0);
r.newPerm("action.vers#create.version", "create.version", 0);
r.newPerm("action.wsp#delete", "delete.wsp", 0);
r.newPerm("action.wsp#set.perms", "admin.node.configRoles", 0);
r.newPerm("action.wsp#update.wsptype", "update.wsp", 0);
r.newPerm("action.wsp#restore", "admin.wspInTrash", 0);
r.newPerm("action.item#set.resps", "write.item.resp", 4);
r.newPerm("action.searches#export.items", "read.node.export", 0);
r.newPerm("action.searches#export.props", "read.node.search", 0);
r.newPerm("action.chain#import.wsp", "create.wsp.import", 0);
r.newPerm("action.src#create.item", "create.item", 128);
r.newPerm("action.src#create.space", "create.space", 128);
r.newPerm("action.src#update.outsideLayer", "update.outsideLayer", 0);
r.newPerm("action.wsp#create.wsp.drf", "create.wsp.drf", 0);
r.newPerm("action.wsp#create.wsp.drv", "create.wsp.drv", 0);
r.newPerm("action.wsp#migrate", "migrate.wsp", 0);
r.newPerm("action.wsp#deletePermanently", "deletePermanently.wspInTrash", 0);
